import { ReactNode } from 'react';

export const ProfileSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <section className="py-3 first:pt-0">
      <h3 className="mb-4 text-base font-semibold text-gray-900">{title}</h3>
      <div>{children}</div>
      <div className="mt-6 h-px bg-gray-200 last:hidden" />
    </section>
  );
};
